import { render } from "./P053.vue?vue&type=template&id=48a3bbb8&scoped=true"
import script from "./P053.vue?vue&type=script&lang=js"
export * from "./P053.vue?vue&type=script&lang=js"

import "./P053.vue?vue&type=style&index=0&id=48a3bbb8&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a3bbb8"]])

export default __exports__